import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import Editor from '@monaco-editor/react';

function PythonEditor() {
  const [code, setCode] = useState('');
  const [output, setOutput] = useState('');
  const editorRef = useRef(null);

  useEffect(() => {
    const loadPyodide = async () => {
      const pyodide = await window.loadPyodide({ indexURL: "https://cdn.jsdelivr.net/pyodide/v0.21.3/full/" });
      window.pyodide = pyodide;
    };
    loadPyodide();
  }, []);

  const runCode = async () => {
    if (window.pyodide) {
      try {
        let result = await window.pyodide.runPythonAsync(code);
        setOutput(result);
      } catch (err) {
        setOutput(err.toString());
      }
    } else {
      setOutput('Pyodide is still loading...');
    }
  };

  const handleEditorDidMount = (editor) => {
    editorRef.current = editor;
  };

  return (
    <section id="playground" style={{ paddingTop: '80px' }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h4" component="h2" gutterBottom>
          Playground
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Python running in your browser via WebAssembly. No server involved.
        </Typography>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        <Box sx={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0' }}>
          <Editor
            height="400px"
            defaultLanguage="python"
            defaultValue="# Write your Python code here"
            onChange={(value) => setCode(value)}
            onMount={handleEditorDidMount}
            theme="vs-dark"
          />
        </Box>

        <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
          <button onClick={runCode}>Run</button>
        </Box>

        {output !== '' && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="overline" sx={{ color: '#2563EB', fontWeight: 700, letterSpacing: '0.1em' }}>
              Output
            </Typography>
            <pre>{output}</pre>
          </Box>
        )}
      </motion.div>
    </section>
  );
}

export default PythonEditor;
